import { ICON_SIZE } from '@/utils/constants/map';
import { createCanvas } from '@/utils/helpers/train-simulation/create-canvas';
import { drawPath } from '@/utils/helpers/train-simulation/draw-path';

const pathDiamond = new Path2D('M 8 1 L 15 8 L 8 15 L 1 8 Z');
const pathBlack = new Path2D(
  'M7.188 10.746c-1.471-.096-2.056-2.121-2.164-3.122.433.384.902.32 1.082.24-.346-.384-.36-1.361-.325-1.801.26.384.686.32.866.24-.173-.769.145-1.361.325-1.561.087.768.541.96.758.96.173-.672.288-1.88.324-2.401.606.48.83 2.121.866 2.882.346-.096.722-.68.866-.96.173.576-.072 1.52-.217 1.92.433-.096.758-.52.866-.72 0 .769-.288 1.521-.433 1.801.52.192.866.08.974 0-.54 2.162-1.948 2.642-3.788 2.522Z'
);
const pathWhite = new Path2D(
  'M8.112 6.584c.28.246.446.591.535.94.098.381.104.758.08.987l-.004.043.041.012c.206.065.39.014.508-.046-.052.539-.366.88-.522.984l-.066.044.066.045c.214.143.44.128.602.079-.28.375-.66.597-.831.666-.432.103-.85.09-1.228-.001-.282-.069-.493-.287-.641-.553a2.3 2.3 0 0 1-.23-.63c.206.17.46.144.581.105l.075-.025-.05-.06a.6.6 0 0 1-.08-.194 3 3 0 0 1-.063-.329 7 7 0 0 1-.05-.553c.137.102.3.182.456.24.195.072.382.114.495.13l.037.007.017-.033c.135-.236.206-.617.242-.99.031-.318.034-.637.03-.868Z'
);

const pathWarningLine = new Path2D();
pathWarningLine.moveTo(5.542, 11.453);
pathWarningLine.lineTo(10.458, 11.453);

export const createHazardIconAtlas = () => {
  const dpr = 2;
  const res = createCanvas(ICON_SIZE, ICON_SIZE, dpr);

  if (!res || !res.ctx) {
    return '';
  }

  const { ctx, canvas } = res;

  ctx.scale(1, 1);

  drawPath(ctx, pathDiamond, { fill: '#ffffff', stroke: '#ef4444', lineWidth: 0.7 });
  drawPath(ctx, pathBlack, { fill: '#000000', stroke: '#000000', lineWidth: 0.106 });
  drawPath(ctx, pathWhite, { fill: '#ffffff', stroke: '#ffffff', lineWidth: 0.106 });
  drawPath(ctx, pathWarningLine, { stroke: '#000000', lineWidth: 0.426, lineCap: 'round' });

  return canvas.toDataURL();
};
